import angular from 'angular';

// Modules
import { FeatureFlagModule } from './featureFlagging/featureFlag.module';
import { GoogleAnalyticsModule } from './googleAnalytics/googleAnalytics.module';
import { SummaryModule } from './summary/summary.module';
import { RestaurantInfoModule } from './restaurantInfo/restaurantInfo.module';
import { PageModule } from './page/page.module';

// Directives and component
import { ABTestApp } from './directives/ab_test_app.component';
import { BackImageDirective } from './directives/backgroundImage.directive';
import { BlockingCalloutComponent } from './directives/blocking_callout.component';
import { CalloutDirective } from './directives/calloutDirective';
import { CartCalloutDirective } from './directives/cartCalloutDirective';
import { CheckoutButtonComponent } from './directives/checkoutButtonDirective';
import { ErrorDirective } from './directives/errorDirective';
import { HeaderDirective } from './directives/headerDirective';
import { OrderInfoComponent } from './directives/orderInfoDirective';
import { RestaurantInfoComponent } from './directives/restaurantInfoComponent';
import { GlobalModals } from './directives/globalModals';
import { ScrollToDirective } from './directives/scrollToDirective';
import { SpotlightImageComponent } from './directives/spotlightImage.component';
import { StickyScrollDirective } from './directives/stickyScroll.directive';

// Filters
import { FromNowFilter } from './filters/fromNowFilter';
import { MomentFilter } from './filters/momentFilter';
import { PhoneNumberFilter } from './filters/phoneNumberFilter';
import { TimeFilter } from './filters/timeFilter';
import { ReceiptTimeFilter } from './filters/receiptTimeFilter';

// Services
import { CalloutService } from './services/calloutService';
import { BlockingCalloutService } from './services/blocking_callout.service';
import { CartDisplayService } from './services/cartDisplayService';
import { LocationService } from './services/locationService';
import { LoginModalService } from './services/loginModalService';
import { PerformanceService } from './services/performance.service';
import { RestaurantHoursService } from './services/restaurantHoursService';
import { UtilityService } from './services/utilityService';


// Controllers imported for testing
import { HeaderController } from './controllers/headerController';

export const CommonModule = angular
    .module('oo.common', [
        FeatureFlagModule,
        GoogleAnalyticsModule,
        SummaryModule,
        RestaurantInfoModule,
        PageModule
    ])
    .controller('headerController', HeaderController)
    .constant('GENERIC_ERROR_MESSAGE', 'Our system is having problems. Please try again or contact the restaurant')
    .constant('GENERIC_ERROR', 'unknown-error')
    .constant('APPROVAL_RULE_ERROR', 'approval-rule')
    .constant('EMPTY_CART_PLACE_ORDER_ERROR', 'empty-cart-place-order')
    .constant('INVALID_DATE_ERROR', 'order-time')
    .constant('OUT_OF_STOCK_ERROR', 'oos-item-removed')
    .constant('LOCAL_STORAGE', { DINING_OPTION: 'diningOption',
        CUSTOMER: 'customer',
        DELIVERY_INFO: 'deliveryInfo',
        PAYMENT: 'payment',
        CART_GUID_MAP: 'cartGuidMap', })
    .directive('callout', CalloutDirective)
    .directive('cartCallout', CartCalloutDirective)
    .directive('errorDiv', ErrorDirective)
    .directive('toastHeader', HeaderDirective)
    .directive('scrollTo', ScrollToDirective)
    .directive('bgImage', BackImageDirective)
    .directive('stickyScroll', StickyScrollDirective)
    .component('abTestApp', ABTestApp)
    .component('checkoutBtn', CheckoutButtonComponent)
    .component('restaurantInfoBox', RestaurantInfoComponent)
    .component('globalModals', GlobalModals)
    .component('orderInfo', OrderInfoComponent)
    .component('spotlightImage', SpotlightImageComponent)
    .component('blockingCallout', BlockingCalloutComponent)
    .filter('fromNow', FromNowFilter)
    .filter('moment', MomentFilter)
    .filter('phoneNumber', PhoneNumberFilter)
    .filter('time', TimeFilter)
    .filter('receiptTime', ReceiptTimeFilter)
    .factory('calloutService', CalloutService)
    .service('blockingCalloutService', BlockingCalloutService)
    .service('loginModalService', LoginModalService)
    .service('performanceService', PerformanceService)
    .factory('cartDisplayService', CartDisplayService)
    .factory('locationService', LocationService)
    .factory('restaurantHoursService', RestaurantHoursService)
    .factory('utility', UtilityService)
    .name;
